import { Component, Input, OnChanges, OnInit } from "@angular/core";

@Component({
  selector: "ab-response-codes-bar",
  templateUrl: "./response-codes-bar.component.html",
})
export class ResponseCodesBarComponent implements OnInit, OnChanges {
  @Input() public data: any;
  public total: number;
  public successBarWidth: number;
  public redirectionBarWidth: number;
  public clientErrorBarWidth: number;
  public serverErrorBarWidth: number;

  public ngOnInit() {
    this.total = 0;
    if (!this.data) {
      return;
    }

    this.calculateBarWidths();
  }

  public ngOnChanges() {
    if (!this.data) {
      return;
    }

    this.calculateBarWidths();
  }

  private calculateBarWidths() {
    this.total =
      this.data.success +
      this.data.redirection +
      this.data.clientError +
      this.data.serverError;

    this.successBarWidth = (this.data.success / this.total) * 100;
    this.redirectionBarWidth = (this.data.redirection / this.total) * 100;
    this.clientErrorBarWidth = (this.data.clientError / this.total) * 100;
    this.serverErrorBarWidth = (this.data.serverError / this.total) * 100;
  }
}
